import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20fresh%20bright%20editorial%20flat%20lay%20of%20assorted%20streetwear%20fashion%20pieces%20including%20a%20pair%20of%20sneakers%20a%20denim%20jacket%20a%20cap%20and%20a%20tote%20bag%20arranged%20with%20airy%20negative%20space%20on%20a%20soft%20off%20white%20background%2C%20gentle%20natural%20daylight%2C%20clean%20modern%20ecommerce%20aesthetic%2C%20balanced%20pastel%20and%20neutral%20tones%2C%20crisp%20high%20detail%20composition&width=1800&height=1000&seq=usfans-hero-bg-v2&orientation=landscape&nocache=true"
          alt="USFans Spreadsheet finds and fashion products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/60 via-background-50/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="mx-auto max-w-4xl flex flex-col items-center text-center py-20 md:py-28">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/80 border border-background-200 px-4 py-1.5 text-xs font-semibold text-foreground-700">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            {t("hero.badge")}
          </span>

          <h1 className="mt-6 text-3xl md:text-5xl font-heading font-bold leading-tight text-foreground-950 max-w-3xl">
            {t("hero.title")}
          </h1>

          <p className="mt-5 text-base md:text-lg text-foreground-600 max-w-2xl leading-relaxed">
            {t("hero.subtitle")}
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center gap-3">
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-8 py-3.5 text-base font-bold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("hero.ctaPrimary")}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-base"></i>
              </span>
            </a>
            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 rounded-full border border-foreground-300 bg-background-50/70 px-8 py-3.5 text-base font-bold text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              {t("hero.ctaSecondary")}
            </a>
          </div>

          <p className="mt-8 text-xs md:text-sm text-foreground-500">
            {t("hero.trust")}
          </p>
        </div>
      </div>
    </section>
  );
}